export default {
  data () {

  },
  computed: {
    attributes: function () {
      return this.$router.currentRoute.meta.fields.attributes
    },
    labels: function () {
      return this.$router.currentRoute.meta.fields.labels
    },
    name: function () {
      return this.$store.state.model
    },
    singularName: function () {
      return this.$pluralize.singular(this.name)
    },
    models: function () {
      return (this.$store.state.data ? this.$store.state.data[this.name] : [])
    },
    columns: function () {
      const columns = []
      const app = this
      const model = this.models.length ? this.models[0] : null
      if (!model) {
        return columns
      }

      Object.keys(model).forEach(function (attribute) {
        if (attribute.charAt(0) === '@') {
          // this is a meta field. Let it be.
          return false
        } else if (app.attributes !== null) {
          if (!app.attributes.includes(attribute)) {
            return false
          }
          columns.push({
            field: attribute,
            label: app.labels.hasOwnProperty(attribute) ? app.labels[attribute] : attribute
          })
        } else {
          columns.push({
            field: attribute,
            label: attribute
          })
        }
      })

      return columns
    }
  }
}
